/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-03-04 17:48:08
 * @LastEditTime: 2025-04-08 10:06:28
 * @LastEditors: ywj@originqc.com
 */
/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-02-08 10:04:49
 * @LastEditTime: 2025-03-03 16:33:44
 * @LastEditors: ywj@originqc.com
 */
import React, { useEffect, useState } from 'react'
import CommonHead from '@/components/common-head';
import Crumb from '@/components/crumb';
import GoodsFilter from '@/components/goods-filter';
import { useLocation } from 'react-router-dom';
// import { goodsLink1,goodsLinkEmpty } from '../home/config'
import Card from '@/components/card'
import { Pagination } from 'antd';
import { getHappily, getListData } from '@/api/list'
import noData from './imgs/noData.png';
import NoData from '@/components/no-data'
import './index.scss';
import { getUrlParam } from '@/utils';
import useBackToTop from '@/hooks/useBackToTop';
import CarouselComponent from '@/components/like-carousel'
import { Spin } from 'antd';
// const settings = {
//   dots: true,
//   infinite: true,
//   speed: 500,
//   slidesToScroll: 5,
//   slidesToShow: 5,
//   autoplay: true
// };
const List: React.FC = () => {

  // const { categoryId }:any = getUrlParam('categoryId');
  // const [happyData, setHappyData] = useState<any>([]); //猜你喜欢
  const [listData, setListData] = useState<any>([]); //列表数据
  const [pageNum, setPageNum] = useState(1); // 表格页码
  const [total, setTotal] = useState<number>();
  const [orderBy, setOrderBy] = useState<number>(1);//1:综合;2:最新;3:销量;4:价格;
  // 新增一个状态来记录价格排序方向，1 表示降序,2表示升序，
  const [priceSortDirection, setPriceSortDirection] = useState<number>(0);
  const [secondId, setSecondId] = useState<any>(getUrlParam('categoryId'));//菜单id
  const [searchName, setSearchName] = useState<any>(getUrlParam('keyword'));
  const [pageSize, setPageSize] = useState(20); // 表格页长
  const [loading, setLoading] = useState(true);
  const { scrollToTop } = useBackToTop(300); // 调用自定义 Hook
  const location = useLocation();


  useEffect(() => {
    scrollToTop();
  }, [])

  useEffect(() => {
    setSecondId(getUrlParam('categoryId') === false ? '' : getUrlParam('categoryId'));
  }, [getUrlParam('categoryId')])
  // useEffect(() => {
  //   handleHappily();
  // }, [])

  useEffect(() => {
    handleListData();
  }, [secondId, searchName, orderBy, priceSortDirection, pageSize, pageNum])
 
  // const handleHappily = async () => {
  //   try {
  //     const res = await getHappily();
  //     setHappyData(res.obj);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {

  //   }
  // };
  const handleListData = async () => {
    try {
      const res = await getListData({
        categoryId: secondId && Number(secondId),
        name: searchName === false ? '' : searchName,
        orderType: priceSortDirection,
        orderBy: orderBy,
        pageNum,
        pageSize,

      });
      if (res.success) {
        setListData(res?.obj?.list);
        setTotal(res.obj?.total);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }

  /**
    * @name: 分页选择
    * @param {*}
    * @return {*}
    */
  const handleChangePagination = (page: number, pageSize: number) => {
    setPageNum(page);
    setPageSize(pageSize);
    scrollToTop();
  };
  return (
    <div>
      <CommonHead type='classify'
        setSecondId={setSecondId}
        setSearchName={setSearchName}
        searchName={searchName} />
      <Spin spinning={loading} size="large">
        <div className="list-content">
          <div className="list-box">
            <Crumb title={'首页'} subTitle={getUrlParam('parentName') || '全部'} />
            <GoodsFilter
              orderBy={orderBy}
              setOrderBy={setOrderBy}
              secondId={secondId}
              setSecondId={setSecondId}
              searchName={searchName}
              setPriceSortDirection={setPriceSortDirection}
              priceSortDirection={priceSortDirection}
              setPageNum={setPageNum}
            />
            {listData.length > 0 && <div className="card-box">
              {(listData.map((item: any, idx: number) => {
                return (
                  <React.Fragment key={idx}>
                  <Card {...item} width={296} is_list="list" />
                </React.Fragment>
                )
              }))}
            </div>}
            {!loading && listData.length === 0 &&
              <div className='no-data'>
                <NoData title='对应搜索条件下没有找到相关商品，换个筛选条件试试吧' />
                {/* <img src={noData} alt='暂无数据' />
              <p className='no-data-text'>对应搜索条件下没有找到相关商品，换个筛选条件试试吧</p> */}
              </div>
            }

            {listData.length > 0 && <Pagination
              current={pageNum}
              // defaultCurrent={1}
              // defaultPageSize={1}
              pageSize={pageSize}
              total={total}
              onChange={(page, pageSize) =>
                handleChangePagination(page, pageSize)
              }
              showQuickJumper
              showSizeChanger={false}
            />}
            {/* <div className="line-box">
            <div className="line"></div>
            <span className='line-text'>猜你喜欢</span>
            <div className="line"></div>
          </div>
          <div className="recommend-box">
            <Carousel   {...settings}>
              {happyData?.length > 0 && happyData?.map((item: any) => (
                <div key={item.id} className="recommend-card-box">
                  <Card {...item} width={234} is_list="like" />
                </div>
              ))}
            </Carousel >
          </div> */}
            <CarouselComponent mode='normal' />
          </div>
        </div>
      </Spin>
    </div>
  )
}

export default List;